/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPaymentTemplate} from '../api'

export const useMutationCreatePaymentTemplate = createReactQueryMutationHook('createPaymentTemplate', createPaymentTemplate)
